import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RestoreAccountStore } from './restore-account.store';
import { LoadingStatus } from '../../shared/enums/loading';

@Component({
  selector: 'anihis-restore-account',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './restore-account.component.html',
  styleUrl: './restore-account.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [RestoreAccountStore],
})
export class RestoreAccountComponent implements OnInit {
  store = inject(RestoreAccountStore);
  private route = inject(ActivatedRoute);

  readonly status = LoadingStatus;

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const userId = params['userId'] ?? '';
      const token = params['token'] ?? '';
      const rola = params['role'] ?? '';

      this.store.restoreAccount(userId, token, rola).subscribe();
    });
  }
}
